/* AW26 sizes left bar on product cards: follows the colour swatch the visitor picks on the card.
   The bar holds {"Colour": [sizes left, sizes total]} in data-aw26-sizes (snippets/kopstorm-aw26-scarcity.liquid). */
(function () {
  function update(box, value) {
    var map;
    try { map = JSON.parse(box.getAttribute('data-aw26-sizes')); } catch (e) { return; }
    if (!map || !Object.prototype.hasOwnProperty.call(map, value)) return;
    var left = map[value][0];
    var total = map[value][1];
    var segments = box.querySelectorAll('.kop-aw26-sizes__bar span');
    for (var i = 0; i < segments.length; i++) {
      segments[i].classList.toggle('is-left', i < left);
      segments[i].classList.toggle('is-off', i >= total);
    }
    var text = box.querySelector('[data-aw26-sizes-text]');
    if (text) text.textContent = (box.getAttribute('data-text') || '').replace('[a]', left).replace('[t]', total);
    box.classList.toggle('is-hidden', left === 0 || left === total);
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'radio') return;
    var card = input.closest('product-card');
    if (!card) return;
    var box = card.querySelector('[data-aw26-sizes]');
    if (box) update(box, input.value);
  });
})();

/* AW26 stock labels on the size buttons of the product page variant picker.
   Data comes from snippets/kopstorm-aw26-size-status.liquid; the labels follow the selected colour. */
(function () {
  if (window.customElements && customElements.get('kop-aw26-sizes')) return;

  var BELL = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.268 21a2 2 0 0 0 3.464 0"/><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"/></svg>';

  function selectedOptions(picker, count) {
    var out = [];
    for (var i = 1; i <= count; i++) {
      var el = picker.querySelector('input[name="option' + i + '"]:checked') ||
        picker.querySelector('input[type="hidden"][name="option' + i + '"]') ||
        picker.querySelector('select[name="option' + i + '"]');
      out.push(el ? el.value : null);
    }
    return out;
  }

  class KopAw26Sizes extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('script[type="application/json"]');
      try { this.data = JSON.parse(json.textContent); } catch (e) { return; }
      this.picker = this.closest('variant-picker');
      if (!this.picker) return;
      this.abort = new AbortController();
      var render = this.render.bind(this);
      var formId = this.getAttribute('form');
      this.picker.addEventListener('change', function () { requestAnimationFrame(render); }, { signal: this.abort.signal });
      document.addEventListener('variant:change', function (e) {
        if (!formId || !e.target || !e.target.getAttribute || e.target.getAttribute('id') === formId) requestAnimationFrame(render);
      }, { signal: this.abort.signal });
      render();
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
    }

    statusFor(variant, value) {
      if (!variant) return null;
      if (!variant.a) return 'out';
      if (variant.p) return 'pre';
      var q = variant.q;
      var lastLimit = this.data.last || 2;
      if (q !== null && q > 0 && q < this.data.low) return q < lastLimit ? 'last' : 'low';
      var sample = this.data.sample && this.data.sample[value];
      if (sample) return sample === 1 ? 'last' : 'low';
      return null;
    }

    render() {
      var d = this.data;
      var sizeIndex = d.size - 1;
      var optionCount = d.variants.length ? d.variants[0].o.length : 0;
      var inputs = this.picker.querySelectorAll('input[type="radio"][name="option' + d.size + '"]');
      if (!inputs.length) return;
      var current = selectedOptions(this.picker, optionCount);
      var left = 0;
      var total = 0;
      var wrap = null;
      var rows = [];

      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        var label = input.nextElementSibling;
        if (!label || !label.matches('[data-option-value]')) label = this.picker.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        if (!label) continue;
        wrap = wrap || label.parentElement;

        var wanted = current.slice();
        wanted[sizeIndex] = input.value;
        var variant = null;
        for (var v = 0; v < d.variants.length; v++) {
          var o = d.variants[v].o;
          var match = true;
          for (var k = 0; k < o.length; k++) { if (o[k] !== wanted[k]) { match = false; break; } }
          if (match) { variant = d.variants[v]; break; }
        }
        if (variant) {
          total++;
          if (variant.a && !variant.p) left++;
        }

        rows.push({ label: label, variant: variant, status: this.statusFor(variant, input.value), q: variant && variant.q !== null ? variant.q : 999 });
      }

      /* At most one Last one and one Low per colour: keep the size with the fewest pieces for each */
      ['last', 'low'].forEach(function (kind) {
        var keep = null;
        rows.forEach(function (r) { if (r.status === kind && (!keep || r.q < keep.q)) keep = r; });
        rows.forEach(function (r) { if (r.status === kind && r !== keep) r.status = null; });
      });

      for (var r = 0; r < rows.length; r++) {
        var label = rows[r].label;
        var status = rows[r].status;
        var note = label.querySelector('.kop-aw26-sz__note');
        label.classList.remove('kop-aw26-sz--low', 'kop-aw26-sz--last', 'kop-aw26-sz--pre', 'kop-aw26-sz--out');
        if (!status) {
          if (note) note.remove();
          label.removeAttribute('aria-description');
          continue;
        }
        if (!note) {
          note = document.createElement('span');
          note.className = 'kop-aw26-sz__note text-xs bold';
          label.appendChild(note);
        }
        label.classList.add('kop-aw26-sz--' + status);
        label.setAttribute('aria-description', d.t[status]);
        if (status === 'out') {
          note.innerHTML = BELL;
        } else {
          note.textContent = d.t[status];
        }
      }

      if (wrap) wrap.classList.add('kop-aw26-sz');
      this.renderBar(wrap, left, total);
    }

    renderBar(wrap, left, total) {
      var d = this.data;
      if (!wrap) return;
      var bar = this.picker.querySelector('.kop-aw26-szbar[data-for="' + d.size + '"]');
      var show = d.bar && total >= 2 && total <= 12 && left > 0 && left < total;
      if (!show) { if (bar) bar.hidden = true; return; }
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'kop-aw26-szbar';
        bar.setAttribute('data-for', d.size);
        bar.innerHTML = '<p class="kop-aw26-szbar__head"><span class="text-sm"></span><span class="text-sm bold"></span></p><span class="kop-aw26-sizes__bar" aria-hidden="true"></span>';
        /* Above the whole size row: the child of the fieldset that holds the buttons, outside any scroll area */
        var anchor = wrap;
        var fieldset = wrap.closest('fieldset');
        while (fieldset && anchor.parentElement && anchor.parentElement !== fieldset) anchor = anchor.parentElement;
        anchor.parentElement.insertBefore(bar, anchor);
      }
      bar.hidden = false;
      var spans = bar.querySelectorAll('.kop-aw26-szbar__head span');
      spans[0].textContent = d.barLabel || '';
      spans[1].textContent = d.t.sizes.replace('[a]', left).replace('[t]', total);
      var segs = bar.querySelector('.kop-aw26-sizes__bar');
      var html = '';
      for (var i = 0; i < total; i++) html += '<span' + (i < left ? ' class="is-left"' : '') + '></span>';
      segs.innerHTML = html;
    }
  }

  customElements.define('kop-aw26-sizes', KopAw26Sizes);
})();
